import { environment } from '@libs/environment';

export const VerificationConfig: VerificationConfig = {
  AVANS: {
    SMS: {
      icon: { url: '', height: 24, width: 24 },
      labels: { default: 'CONFIRM.CODE_WAS_SEND', retry: 'CONFIRM.SMS_RETRY' },
    },
    PHONE: {
      icon: { url: '', height: 24, width: 24 },
      labels: { default: 'CONFIRM.WAIT_CALL', retry: 'CONFIRM.CALL_RETRY' },
    },
    IVR: {
      icon: { url: '', height: 24, width: 24 },
      labels: { default: 'CONFIRM.WAIT_CALL', retry: 'CONFIRM.CALL_RETRY' },
    },
  },
  STARFIN: {
    SMS: {
      icon: { url: './assets/images/icons/icon-sms-outline.svg', height: 32, width: 32 },
      labels: { default: 'CONFIRM.CODE_WAS_SEND', retry: 'CONFIRM.SMS_RETRY' },
    },
    PHONE: {
      icon: { url: './assets/images/icons/icon-auth-phone.png', height: 32, width: 32 },
      labels: { default: 'CONFIRM.WAIT_CALL', retry: 'CONFIRM.CALL_RETRY' },
    },
    IVR: {
      icon: { url: './assets/images/icons/icon-auth-phone.png', height: 32, width: 32 },
      labels: { default: 'CONFIRM.WAIT_CALL', retry: 'CONFIRM.CALL_RETRY' },
    },
    VIBER: {
      icon: { url: 'assets/img/viber.png', height: 32, width: 32 },
      labels: { default: 'CONFIRM.CODE_WAS_SEND', retry: 'CONFIRM.SMS_RETRY' },
    },
  },
  SUNCREDIT: {
    SMS: {
      icon: { url: './assets/images/icons/icon-sms-outline.svg', height: 24, width: 24 },
      labels: { default: 'CONFIRM.CODE_WAS_SEND', retry: 'CONFIRM.SMS_RETRY' },
    },
    PHONE: {
      icon: { url: '', height: 0, width: 0 },
      labels: { default: 'CONFIRM.WAIT_CALL', retry: 'CONFIRM.CALL_RETRY' },
    },
    IVR: {
      icon: { url: '', height: 24, width: 24 },
      labels: { default: 'CONFIRM.WAIT_CALL', retry: 'CONFIRM.CALL_RETRY' },
    },
    VIBER: {
      icon: { url: 'assets/img/viber.png', height: 24, width: 24 },
      labels: { default: 'CONFIRM.CODE_WAS_SEND', retry: 'CONFIRM.SMS_RETRY' },
    },
  },
};

export type VerificationType = keyof typeof VERIFICATION_CONFIG;

export const VERIFICATION_CONFIG: VerificationConfigForGroup = VerificationConfig[environment.group];

export const VerificationTypeEnum = {
  SMS: 'SMS',
  PHONE: 'PHONE',
  IVR: 'IVR',
  VIBER: 'VIBER',
};

export interface VerificationRow {
  icon: { url: string; height: number; width: number };
  labels: { default: string; retry: string };
}

export interface VerificationConfigForGroup {
  [key: string]: VerificationRow;
}

export interface VerificationConfig {
  AVANS: VerificationConfigForGroup;
  STARFIN: VerificationConfigForGroup;
  SUNCREDIT: VerificationConfigForGroup;
}

export interface VerificationTypeEnumType {
  [key: VerificationType]: VerificationType;
}
